import React, { useState } from 'react';
import { Box, CircularProgress, Skeleton, Typography } from '@mui/material';
import { abbreviateNumber, formatCurrencyBasedOnCountryCode } from 'src/utils/functions';
import { useSelector } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
export const MapListingCountInfoBox = ({
  open,
  listingsLength,
  matches,
}: {
  open: boolean;
  listingsLength: number;
  matches: boolean;
}) => {
  const visibleMapSupply = useSelector(state => (state as any).dashboard.visibleMapSupply);
  const isUserAllowed = useSelector(state => (state as any).dashboard.isUserAllowed);
  const search = useSelector(state => (state as any).dashboard.search);
  const useFullMarkers = useSelector(state => (state as any).dashboard.useFullMarkers);
  const [hovered, setHovered] = useState(false);

  const isLoading = visibleMapSupply.loading || visibleMapSupply.data == null;
  // const count = useFullMarkers ? listingsLength : visibleMapSupply.data;
  const count = visibleMapSupply.data;

  if (!open) return <></>;

  return (
    <Box
      sx={{
        background: '#0008',
        borderRadius: 4,
        padding: '5px 10px',
        backdropFilter: 'blur(4px)',
        height: matches && !hovered ? '20px' : '40px',
        overflow: 'hidden',
        pointerEvents: 'auto',
      }}
    >
      {isLoading ? (
        matches ? (
          <Typography variant="body2" style={{ color: '#fff' }}>
            <CircularProgress size={20} sx={{ color: 'white' }} />
          </Typography>
        ) : (
          <Skeleton variant="text" height="20px" sx={{ padding: '-5px -10px' }}>
            <Typography variant="body2" style={{ color: '#fff' }}>
              {/* the below text is dummy. Just to give a default width tot he component */}
              <div>listings are available in this area. Zoom in to see.</div>
            </Typography>
          </Skeleton>
        )
      ) : matches && !hovered ? (
        <>
          <Typography variant="body2" style={{ color: '#fff' }} onClick={() => setHovered(true)}>
            {abbreviateNumber(count, false)} listings
          </Typography>
        </>
      ) : (
        <Typography
          variant="body2"
          style={{ color: '#fff' }}
          onClick={() => matches && setHovered(false)}
        >
          <div>
            {count > 0 ? (
              <>
                <span>{abbreviateNumber(count, false)}</span>{' '}
                <span>listings are available in this area. {matches && '⛌'}</span>
                <br />
                <span>Zoom in to see.</span>{' '}
              </>
            ) : (
              <span>Select the matching market on the map to view listings in that area.</span>
            )}
          </div>
        </Typography>
      )}
    </Box>
  );
};
